/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
import Api from "@/helpers/api.js";

export default {
	async getApi({commit, dispatch}) {
		try {
			const data = await Api.get("/permission");
			commit("ADD_ITEM", Object.assign(data.data));
			dispatch("getRolPermission");
		} catch (e) {
			console.error(e);
		}
	},

	async createPermission({commit, dispatch}, payload) {
		try {
			const data = await Api.post("/permission", payload);
			return data.data;
		} catch (e) {
			console.error(e);
		}
	},

	async createApi({commit, dispatch}, payload) {
		try {
			const data = await Api.post("/permission", payload);
			return data.data.id;
		} catch (e) {
			console.error(e);
		}
	},

	async deleteApi({commit, dispatch}, payload) {
		try {
			await Api.delete("/permission/" + payload);
			await dispatch("getApi");
			// statements
		} catch (e) {
			console.error(e);
		}
	},

	async updateApi({commit, dispatch}, payload) {
		try {
			await Api.put("/permission/" + payload.id, payload.payload);
			await dispatch("getApi");
			// statements
		} catch (e) {
			console.error(e);
		}
	},

	async deleteRolPermission({commit, getters, dispatch}) {
		try {
			let promises = [];
			for (let i in getters.filterRolPermission) {
				const promise = Api.delete(`/rolepermission/${getters.filterRolPermission[i].id}`);
				promises.push(promise);
			}
			await Promise.all(promises);
			dispatch("getRolPermission");
		} catch (e) {
			console.error(e);
		}
	},

	async rolPermission({commit}, payload) {
		try {
			let promises = [];
			for (let i in payload.roles) {
				const data = {
					role_id: payload.roles[i],
					permission_id: payload.id,
				};
				const promise = Api.post("/rolepermission", data);
				promises.push(promise);
			}
			await Promise.all(promises);
		} catch (e) {
			console.error(e);
		}
	},

	async getRolPermission({commit}) {
		try {
			const result = await Api.get("/rolepermission");
			commit("RELATION_SHIP_ROL_PERMISSION", result.data);
		} catch (e) {
			console.error(e);
		}
	},
};
